var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "boss-title-small" },
    [
      _vm._l(_vm.breadcrumbs, function (breadcrumb, i) {
        return [
          breadcrumb.pathName
            ? _c(
                "router-link",
                {
                  key: i,
                  attrs: {
                    to: { name: breadcrumb.pathName },
                    "data-test": "breadcrumb-router-" + i,
                  },
                },
                [_vm._v(_vm._s(breadcrumb.name) + _vm._s(_vm.joinFormat(i)))]
              )
            : _c("span", { key: i }, [
                _vm._v(
                  _vm._s(breadcrumb.name) + _vm._s(_vm.joinFormat(i)) + "\n    "
                ),
              ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }